import React from 'react';
import {
  string,
  arrayOf,
  shape,
} from 'prop-types';
import { Small, SocialMediaLink } from 'components/common';
import './SocialMedia.scss';

const SocialMedia = ({ label, links }) => (
  <div
    className="sm-container"
    itemScope=""
    itemType="http://schema.org/Organization"
  >
    <div className="sm-title">
      <Small>
        <strong>{label}</strong>
      </Small>
    </div>
    <div className="sm-links">
      {links && links.map(link => (
        <div
          className="sm-link-wrapper"
          key={link.iconName}
        >
          <SocialMediaLink
            link={{ href: link.href || '', icon: link.iconName || '', title: link.label || '' }}
          />
        </div>
      ))}
    </div>
  </div>
);

SocialMedia.defaultProps = {
  label: null,
  links: null,
};

SocialMedia.propTypes = {
  label: string,
  links: arrayOf(
    shape({
      label: string,
      href: string,
      iconName: string,
    })
  ),
};

export default SocialMedia;
